module.exports = __webpack_public_path__ + "static/media/BCL.bb4f7f9e.svg";